import Header from 'components/Dashboard/Header';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ReadMe } from 'services/me';
import { ThemedComponent } from 'ui/theme';
import { Content, DashboardBody, DashboardBodyContent } from './styled';

export default function ContainerAuthenticated({ children }) {
  const { sideOpened, setSideOpened, setUser } = useContext(CoreContext);
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const completeNext = useCallback(() => navigate('login'), [navigate]);
  // revalida a sessao pelo cookie e ja popula o usuario no contexto
  const init = useCallback(async () => {
    const me = await ReadMe();
    if (me?.id) {
      setUser(me);
    } else {
      completeNext();
    }
  }, [completeNext, setUser]);

  useEffect(() => {
    init();
    window.scrollTo(0, 0);
  }, [init]);

  return (
    <ThemedComponent>
      <Content>
        <DashboardBody>
          <Header opened={sideOpened} setOpened={setSideOpened} />
          <DashboardBodyContent opened={sideOpened}>
            {children}
          </DashboardBodyContent>
        </DashboardBody>
      </Content>
    </ThemedComponent>
  );
}
